import AbstractCRMApi from '../../Api/AbstractCRMApi';

export default abstract class AbstractCasinoCRMApi extends AbstractCRMApi {
    protected apiPrefix: string = '';
    protected endpoint: string = '';
}
